import { Button } from '@/shared/ui/button.tsx';
import { Form, FormItem, FormField, FormControl } from '@/shared/ui/form.tsx';
import { StarInput } from '@/shared/inputs/StarInput';
import TextareaWithLabel from '@/shared/inputs/TextareaWithLabel';
import { Label } from '@/shared/ui/label.tsx';
import {
  Popover,
  PopoverClose,
  PopoverContent,
  PopoverTrigger,
} from '@/shared/ui/popover.tsx';
import { zodResolver } from '@hookform/resolvers/zod';
import { Star } from 'lucide-react';
import { useForm } from 'react-hook-form';
import { z } from 'zod';
import { useAddFeedback } from '../../api/themes';
import { AuthContext, AuthContextType } from '@/features/app-layout/context';
import { useContext } from 'react';

export const FeebackFormSchema = z.object({
  stars: z.number().optional(),
  text: z.string().optional()
})

export type FeedbackFormType = z.infer<typeof FeebackFormSchema>

const FeedbackPopover = ({ post_id }: { post_id: number }) => {

  const { addFeedback } = useAddFeedback()

  const { username } = useContext<AuthContextType>(AuthContext)

  const feedbackForm = useForm<FeedbackFormType>({
    resolver: zodResolver(FeebackFormSchema)
  })

  const submitHandler = (data: FeedbackFormType) => {
    if (username) {
      addFeedback({
        post_id: post_id,
        rating: data.stars ? data.stars : null,
        comment: data.text ? data.text : null,
        user_name: username
      })
    }
    feedbackForm.reset()
  }

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button variant='outline' className='h-7 flex items-center gap-1 text-xs border-0 shadow-none font-poppins tracking-wide text-gray-500'>
          Feedback to siAi <Star size={7} className='text-xs size-7' />
        </Button>
      </PopoverTrigger>
      <PopoverContent className='w-80 p-2 shadow-md rounded-xl'>
        <Form {...feedbackForm}>
          <form className="py-1" onSubmit={feedbackForm.handleSubmit(submitHandler)}>
            <Label className='font-poppins tracking-wide text-sm text-gray-500'>Help siAi get better</Label>
            <div className="flex items-center w-full justify-between px-2">
              <FormField
                control={feedbackForm.control}
                name="stars"
                render={({ field }) => (
                  <FormItem>
                    <FormControl>
                      <StarInput value={field.value} onChange={field.onChange} />
                    </FormControl>
                  </FormItem>
                )}
              />
              <PopoverClose>
                <Button type='submit' variant="outline" size="icon" className='rounded-full size-7 border-0 text-xs font-poppins'>Submit</Button>
              </PopoverClose>
            </div>
            <TextareaWithLabel<FeedbackFormType> fieldTitle="" nameInSchema="text" rows={3} />
          </form>
        </Form>
      </PopoverContent>
    </Popover>
  )
}

export default FeedbackPopover;
